import React from 'react'
import { withTranslation } from 'react-i18next'
import dayjs from 'dayjs'

const weekdays = Array(7)
  .fill()
  .map((item, index) => {
    const day = dayjs().day(index)
    return { fullname: day.format('dddd'), shortname: day.format('dd') }
  })

const getWeekName = (day) => {
  let weekNames = {
    'Su': "di", 'Mo': "lu", 'Tu': "ma", 'We': "me", 'Th': "je", 'Fr': "ve", 'Sa': "sa"
  }
  return weekNames[day]
}

const DaysOfTheWeek = ({ i18n }) => {
  return (
    <div className="Calendar-days Calendar-row" aria-disabled="true" role="presentation" aria-hidden="true">
      {weekdays.map((day) => {
        const dayTranslated = i18n.language === 'en' ? day.shortname : getWeekName(day.shortname)
        return (
          <span key={day.shortname} className="Calendar-item Calendar-item--day" aria-label={dayTranslated}>
            {dayTranslated}
          </span>
        )
      })}
    </div>
  )
}

export default withTranslation('common')(DaysOfTheWeek)
